import { EMouseButton } from './types';

export const AVAILABLE_MOUSE_BUTTONS = [EMouseButton.LEFT, EMouseButton.RIGHT];
